import moment from "moment";
function convertToSeconds(value = "1") {
  return moment.duration(value).asSeconds();
}
export default convertToSeconds;
